export default "__VITE_ASSET__CPpZQdNR__"